.checkCircle {
    width: 11.25rem;
    height: 11.25rem;
}


.successContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0.875rem;
    padding: 4rem;
}

.successIcon {
    width: 32px;
    height: 32px;
}

.successTitle {
    color: #4CAF50;
    font-size: var(--fs-heading)
}

.successMessage {
    color: var(--static-text-standard);
    font-size: var(--fs-small);
}